export const ROLE_TOASTS = {
  CREATED_ROLE_TOASTS: 'New role {name} successfully created',
  ROLE_DELETED: 'Role successfully deleted',
  ROLE_UPDATED: 'Role successfully updated',
};
